/**
 * @name monkeyPatch
 *
 * @description Monkey-patches any function on any object
 *
 * @example
 * import { monkeyPatch } from '@workbench/core';
 *
 * const customBeforeFn = (done: Function) => {
 *   console.log('BEFORE');
 *   done();
 * };
 *
 * const customAfterFn = () => {
 *   console.log('AFTER');
 * };
 *
 * monkeyPatch(this.el, 'remove', customBeforeFn, customAfterFn);
 */
export const monkeyPatch = (scope: unknown, fnName: string, beforeFn?: (done: (value?: unknown) => void) => void, afterFn?: () => void): void => {
  const methodAlias = '__wb__' + fnName;
  scope[methodAlias] = scope[fnName];

  scope[fnName] = () => {
    const execute = () => {
      scope[methodAlias]();

      if (afterFn) {
        afterFn();
      }
    };

    if (beforeFn) {
      new Promise((resolve) => beforeFn(resolve)).then(execute);
    } else {
      execute();
    }
  };
};
